import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { GroupMenuComponent } from './group-menu.component';

@NgModule({
  declarations: [GroupMenuComponent],
  exports: [GroupMenuComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule]
})
export class GroupMenuModule {}
